<template>
  <div class="todo-list">
    <!-- 待办列表 -->
    <div class="todo-content">
      <el-empty v-if="!loading && todos.length === 0" description="暂无待办事项" />
      
      <div v-else class="todo-items">
        <TodoItem
          v-for="todo in todos"
          :key="todo.id"
          :todo="todo"
          @handle-todo="$emit('handle-todo', $event)"
        />
      </div>
    </div>

    <!-- 加载更多 -->
    <div v-if="shouldShowLoadMore" class="todo-load-more">
      <el-button 
        type="primary" 
        :loading="loading"
        @click="$emit('load-more')"
        style="width: 100%;"
      >
        {{ loading ? '加载中...' : '加载更多' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import TodoItem from './TodoItem.vue'

export default {
  name: 'TodoList',
  components: {
    TodoItem
  },
  props: {
    todos: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // 只有当总数超过10条且还有更多数据时才显示加载更多按钮
    shouldShowLoadMore() {
      return this.total > 10 && this.hasMore && this.todos.length > 0
    }
  }
}
</script>

<style scoped>
.todo-list {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.todo-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.todo-items {
  padding: 0;
}

.todo-load-more {
  padding: 16px;
  text-align: center;
  border-top: 1px solid #EBEEF5;
  background-color: #F5F7FA;
}

/* 滚动条样式 */
.todo-content::-webkit-scrollbar {
  width: 6px;
}

.todo-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.todo-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.todo-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
